import { Box } from '@mui/material';
import {
    ResponsiveContainer, LineChart, Line,
    CartesianGrid, XAxis, YAxis, Tooltip, Legend
} from 'recharts';

const SearchesChart = ({ data }) => {
    return (
        <Box sx={{ height: 'calc(100vh - 135px)', width: '100%', p: 2 }}>
            <ResponsiveContainer width="100%" height="90%">
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="totalSearches" name="סה״כ חיפושים" stroke="#8884d8" />
                    <Line type="monotone" dataKey="uniqueSearchers" name="משתמשים שונים" stroke="#82ca9d" />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default SearchesChart;
